import { API } from "@/services"

export const AUTH_ENDPOINTS = {
  login(data={}){
    return API.Axios.humanify.v1.request({
      url: `admin/auth/login`,
      method: 'POST',
      data,
      authentication: true,
    })
  },
  refreshToken(data={}){
    return API.Axios.humanify.v1.request({
      url: `admin/auth/refresh-token`,
      method: 'POST',
      data,
      authentication: true,
    })
  },
  logout(data={},headers){
    return API.Axios.humanify.v1.request({
      url: `admin/auth/logout`,
      method: 'POST',
      data,
      headers,
      authentication: true,
    })
  },
}